import styled from 'styled-components';
import PrimaryButton, { styleTypes } from '../../ReactComponent/PrimaryButton';
import { Div } from '../../../theme/typographySitecore';
import { MediaQuery } from '../../../theme/style-helpers';

export const Form = styled.form`
  display: flex;
  flex-direction: column;

  ${MediaQuery.small`
    align-items: center;
  `}
`;

export const FieldContainer = styled.div`
  width: 100%;
  margin-bottom: 40px;

  ${MediaQuery.small`
    max-width: 350px;
  `}
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const HeaderSummary = styled(Div)`
  margin-top: 12px;
`;

export const ButtonContainer = styled.div`
  display: grid;
  grid-template-columns: 100% 100%;
  grid-gap: 32px;
  grid-template-areas: "button-2" "button-1";

  ${MediaQuery.small`
    grid-template-columns: auto minmax(0, 1fr);
    grid-template-areas: "button-1 button-2";
  `}

  button {
    font-family: Montserrat;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }
}
`;

export const CancelButton = styled(PrimaryButton).attrs(() => ({ styleType: styleTypes.SECONDARY }))`
  width: 100%;
  grid-area: button-1;
`;

export const ResetPasswordButton = styled(PrimaryButton)`
  width: 100%;
  grid-area: button-2;
`;
